import script from "./ProfileDdList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileDdList.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileDdList.vue?vue&type=style&index=0&id=0ae88f06&lang=css"

const __exports__ = script;

export default __exports__